<script>
import { LocationPicker } from '@ibiquity/dashboard.location-selector';

export default {
  name: 'PanelLocationPicker',
  extends: LocationPicker,
};
</script>

<style lang="scss">
@import "~@/assets/scss/vuemultiselect";

.dash-location-picker {
  .dash-location-picker-option {
    .dash-location-picker-option-label {
      flex: 1;
      font-weight: $weight-normal;
      color: $input-color;
    }

    .dash-location-picker-option-icon {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
}
</style>
